import Card, { SUIT } from "./card";

export interface IHand {
    chairIndex: number;
    cards: Card[];
}

export default class Hand implements IHand {
    chairIndex: number;
    cards: Card[] = [];

    constructor(chairIndex: number) {
        this.chairIndex = chairIndex;
    }

    static fromObject(o: IHand) {
        const h = new Hand(o.chairIndex);

        for (const c of o.cards) {
            h.cards.push(Card.fromObject(c));
        }
        return h
    }

    createCards() {
        // add card if needed
        const cardsToAdd = 13 - this.cards.length;
        for (let j = 0; j < cardsToAdd; j++) {
            this.cards.push(new Card());
        }
    }

    fromString(bsol: string) {
        const cvalues = "AKQJT98765432";
        let s = 4; // spades

        this.cards = [];

        for (let c of bsol) {
            if (c === '.') {
                s--;
            } else {
                let v = cvalues.indexOf(c) + 1;

                if (v >= 0) {
                    let card = new Card();
                    card.height = v;
                    card.suit = s;
                    this.cards.push(card)
                }
            }
        }
    }

    /**
     * Returns a string of the hand in a BSOL format.
     * The string holds the cards for all four suits, in the order Spades, 
     * Hearts, Diamonds, Clubs, with the individual strings 
     * separated by a "." character. 
     * The cards within a suit are represented by their face values with 
     * a 10 being denoted as "T".
     * <p>
     * An example would be:
     * Q853.KJT82.K5.J5 or .KJT876542.K5.J5
     * 
     * @return a string of the hand in a BSOL format
     */
    toString(): string {
        const cardValues = "AKQJT98765432";
        let s = "";
        let h = "";
        let d = "";
        let c = "";

        console.assert(this.cards.length === 13, "hand to string doesn't have 13 cards.");

        for (const card of this.cards) {
            if (card.isValid()) {
                const index = card.height - 1;
                const height = cardValues.substring(index, index + 1);

                switch (card.suit) {
                    case SUIT.CLUBS:
                        c += height;
                        break;
                    case SUIT.HEARTS:
                        h += height;
                        break;
                    case SUIT.SPADES:
                        s += height;
                        break;
                    case SUIT.DIAMONDS:
                        d += height;
                        break;
                    default:
                }
            }
        }

        return s + "." + h + "." + d + "." + c;
    }
}